import { render } from "./CloseIcon.vue?vue&type=template&id=217fe45e&scoped=true"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"

import "./CloseIcon.vue?vue&type=style&index=0&id=217fe45e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217fe45e"]])

export default __exports__